import { calcInsideBorder, calcOutsideBorder } from '../phone';
import {
    Appbar,
    Container,
    Content,
    Dots,
    Header,
    HorizontalCards,
    Profile,
    Title,
    VerticalCards,
} from './style';

interface Props {
    percMultiplier: number,
    percPhone: number,
    width: number,
    height: number,
}

const AppDesign: React.FC<Props> = ({
    width, percPhone, height, percMultiplier,
}) => {
    const insideBorder = calcInsideBorder({ width, percPhone });
    const outsideBorder = calcOutsideBorder({ width, percPhone });

    return (
        <Container style={{
            backgroundColor: 'red',
            width: width - 2 * (outsideBorder + insideBorder),
            height: height - 2 * (outsideBorder + insideBorder),
        }}
        >
            <Appbar>
                <Profile />
                <Header percMultiplier={percMultiplier} />
                <Dots>
                    <div>
                        <div />
                        <div />
                        <div />
                    </div>
                </Dots>
            </Appbar>
            <Content>
                <Title percMultiplier={percMultiplier} />
                <HorizontalCards>
                    <div />
                    <div />
                    <div />
                    <div />
                </HorizontalCards>
                <Title percMultiplier={percMultiplier} style={{ width: '50%' }} />
                <VerticalCards percMultiplier={percMultiplier}>
                    <div />
                    <div />
                    <div />
                </VerticalCards>
            </Content>
        </Container>
    );
};

export default AppDesign;
